import { render, staticRenderFns } from "./RegisterPassword2.vue?vue&type=template&id=0fd1ff9a"
import script from "./RegisterPassword2.vue?vue&type=script&lang=js"
export * from "./RegisterPassword2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports